<template>
  <span class="app-label" :class="className">
    <template v-if="hasText">{{ text }}</template>
    <slot v-else />
  </span>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import { PropColorType } from './types'

export default defineComponent({
  name: 'AppLabel',
  props: {
    color: {
      type: String as PropType<PropColorType>,
      default: 'success'
    },
    text: {
      type: String,
      default: undefined
    }
  },
  setup(props) {
    const className = computed(() => 'app-label-' + props.color)
    const hasText = computed(() => props.text !== undefined)

    return {
      className,
      hasText
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.app-label {
  display: inline-block;
  padding: 0 $spacing-unit * 2;
  font-weight: bold;
  line-height: 20px;
  border-radius: $spacing-unit * 2;
}

.app-label-default {
  color: $text-color-white;
  background: $text-color;
}

.app-label-white {
  color: $text-color;
  background: $text-color-white;
}

.app-label-subtext {
  color: $text-color-white;
  background: $sub-text-color;
}

.app-label-disabled {
  color: $text-color-white;
  background: $disabled-color;
}

.app-label-info {
  color: $text-color-white;
  background: $info-color;
}

.app-label-primary {
  color: $text-color-white;
  background: $primary-color;
}

.app-label-link {
  color: $text-color-white;
  background: $link-color;
}

.app-label-success {
  color: $text-color-white;
  background: $success-color;
}

.app-label-danger {
  color: $text-color-white;
  background: $danger-color;
}
</style>
